import type { ReactNode } from "react";
import { formatNullable } from "@/lib/format";

interface AdminInfoRowProps {
  label: string;
  value?: ReactNode;
  dense?: boolean;
  bordered?: boolean;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
}

const AdminInfoRow = ({
  label,
  value,
  dense = false,
  bordered = false,
  className = "",
  labelClassName = "",
  valueClassName = "",
}: AdminInfoRowProps) => {
  const rowClassName = [
    "flex items-start justify-between gap-3",
    dense ? "py-1.5" : "px-4 py-2",
    bordered ? "border-b border-slate-50 last:border-b-0" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const labelBaseClassName = dense
    ? "text-xs text-slate-500 shrink-0"
    : "text-xs text-slate-500 flex-shrink-0 mr-3 mt-0.5";
  const valueBaseClassName = dense
    ? "text-xs text-slate-700 font-medium text-right"
    : "text-xs font-medium text-slate-700 text-right";
  const displayValue =
    value == null
      ? formatNullable(null)
      : typeof value === "string" || typeof value === "number" || typeof value === "boolean"
        ? formatNullable(value)
        : value;

  return (
    <div className={rowClassName}>
      <span className={[labelBaseClassName, labelClassName].filter(Boolean).join(" ")}>{label}</span>
      <span className={[valueBaseClassName, valueClassName].filter(Boolean).join(" ")} style={{ wordBreak: "keep-all" }}>
        {displayValue}
      </span>
    </div>
  );
};

export default AdminInfoRow;
